import { render, staticRenderFns } from "./PackingStatus.vue?vue&type=template&id=81cec1fa"
import script from "./PackingStatus.vue?vue&type=script&lang=js"
export * from "./PackingStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports